

export default {
    name: 'discussion',
    props: ['source'],
    data() {
        return {

        }
    },
    computed: {
        /** 列表带 edit_status 时优先用它；没有该字段再按 status */
        reviewLabel() {
            const source = this.source || {}
            const editStatus = source.edit_status
            const hasEditStatus = editStatus !== undefined && editStatus !== null
            if (hasEditStatus) {
                if (editStatus === 0) return this.$t('page.EDIT_CONTENT_PENDING')
                if (editStatus === -3) return this.$t('page.EDIT_CONTENT_REJECTED')
                return ''
            }
            if (source.status == 0) return '! Post is being moderated'
            if (source.status == -1) return 'deleted'
            if (source.status == -2) return 'Audit not passed'
            return ''
        },
    },
    created() {

    },
    watch: {
        source(val) {
            this.source = val
        }
    },
    methods: {
        jumpDetails() {
            this.$router.push({
                path: `/discussion/${this.source.id}`
            })
        },

    },

    filters: {
        getSimpleText(html) {
            var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
            var msg = html.replace(re1, '');//执行替换成空字符
            return msg;
        }
    }
}
